var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAccessibilityHomeVisit = function SvgAccessibilityHomeVisit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    vectorEffect: "non-scaling-stroke",
    viewBox: "0 0 30 30"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    vectorEffect: "non-scaling-stroke",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M8.143 12.955h4.008v4.008H8.143zm9.642 0h4.008v4.008h-4.008z"
  }), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M4.095 12.872v15.952h8.889v-6.15h3.968v6.15h8.77V12.832h2.659a.397.397 0 0 0 .277-.714L15.722 1.483a.845.845 0 0 0-1.111 0L9.214 5.77m-5.159 7.062h-2.46a.437.437 0 0 1-.278-.754l2.738-2.182V5.769h5.159"
  }))));
};
export default SvgAccessibilityHomeVisit;